export const ItemTypes = {
  COSTUME: "costume"
};
